export const activationStatuses = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
};
